<template>
    <div class="Map">
       {{$t('DataInfo.Development')}}
    </div>
</template>

<script>
export default {

}
</script>

<style scoped lang='scss'>
    .Map{
        text-align: center;
        margin: 60px auto;
        font-size: 20px;
        color: #999;
        font-weight: 600
    }
</style>